<div class="my-card-container" @fadeIn>
  <mat-card class="my-card">
    <div *ngIf="logoUrl && showLogo" class="logo-container">
      <img [src]="logoUrl" alt="Logo" class="card-logo" />
    </div>
    <mat-card-header>
      <mat-card-title>{{ header }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>{{ description }}</p>
    </mat-card-content>
    <mat-card-actions>
      <button *ngIf="showActions" mat-flat-button color="primary" (click)="navigate()">
        {{ button_label }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
